import Hexagon from './Hexagon';

export default Hexagon;
